import { render } from "./ConfigurationDetails.vue?vue&type=template&id=bcb55820"
import script from "./ConfigurationDetails.vue?vue&type=script&lang=js"
export * from "./ConfigurationDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__